import React from 'react';
import { Box, Typography, IconButton, Tooltip, CircularProgress } from '@mui/material';
import * as fieldListStyle from '../../fields/fieldtab/FieldListStyle';
import { injectIntl } from 'react-intl';
import { createSvgIcon } from '@mui/material/utils';

const ActionBar = ({
  intl,
  data,
  selectedCount,
  onClose,
  onDelete,
  onExport,
  selectedItems,
  isExporting,
  errorMessage,
  isAllSelected
}) => {
  let activityText = '';
  const selectedCountLength = selectedCount;

  if (selectedCountLength === 1 && Array.isArray(data)) {
    const selectedTask = data.find(task => task?.id === selectedItems[0]);
    activityText = selectedTask?.activityName || '';
  } else if (selectedCountLength > 1) {
    activityText = `${selectedCountLength} er valgt`;
  }

  const CloseIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="#191C1C" />
    </svg>,
    'CloseIcon'
  );

  const ExportIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M12 16.501L7 11.501L8.4 10.051L11 12.651V4.50098H13V12.651L15.6 10.051L17 11.501L12 16.501ZM6 20.501C5.45 20.501 4.97917 20.3051 4.5875 19.9135C4.19583 19.5218 4 19.051 4 18.501V15.501H6V18.501H18V15.501H20V18.501C20 19.051 19.8042 19.5218 19.4125 19.9135C19.0208 20.3051 18.55 20.501 18 20.501H6Z" fill="#3F4949" />
    </svg>,
    'ExportIcon'
  );

  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: '#E6E9E8',
        paddingLeft: '16px',
        borderRadius: '0',
        width: '100%',
        transition: 'box-shadow 0.3s ease',
        height: '48px'
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px'
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Box sx={{ padding: '8px' }}>
          <Typography style={fieldListStyle.listRowItem}>{activityText}</Typography>
        </Box>

        {/* Export Button */}
        <Tooltip
          title={
            <span style={fieldListStyle.iconTextStyle}>
              {intl.formatMessage({ id: 'REPORTS_EXPORT' })}
            </span>
          }
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#2D3131',
                borderRadius: '4px',
                padding: '4px 8px',
              },
            },
          }}
        >
          {/* errorMessage */}
          <IconButton
            onClick={onExport}
            disabled={selectedCount === 0 || isExporting}
            sx={{ position: 'relative', width: '40px', height: '40px' }}
          >
            {/*{isExporting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <ExportIcon />
            )}*/}
            <ExportIcon />
            {errorMessage && errorMessage != null(
              errorMessage
            )}
          </IconButton>
        </Tooltip>

        {/* Delete Button */}
        <Tooltip
          title={
            <span style={fieldListStyle.iconTextStyle}>
              {intl.formatMessage({ id: 'DELETE_TASK' })}
            </span>
          }
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#2D3131',
                borderRadius: '4px',
                padding: '4px 8px',
              },
            },
          }}
        >
          <IconButton
            onClick={onDelete}
            sx={{ paddingLeft: '8px' }}
            disabled={selectedCount === 0}
          >
            <img src="/images/DeleteIcon.svg" alt="Delete" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default injectIntl(ActionBar);
